export default __webpack_public_path__ + "static/media/slogan.54cfa7ec.png";